var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09319 1.15527L15.0383 4.12782C15.5434 4.37879 15.8629 4.89403 15.8632 5.45803V12.5401C15.8629 13.1041 15.5434 13.6194 15.0383 13.8703L9.09319 16.8429C8.67453 17.0524 8.18163 17.0524 7.76297 16.8429L1.81788 13.8703C1.31329 13.6161 0.996501 13.0977 1.00043 12.5327V5.45803C1.00073 4.89403 1.32024 4.37879 1.82531 4.12782L7.7704 1.15527C8.18703 0.948243 8.67656 0.948243 9.09319 1.15527Z",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23819 4.65552L8.43175 8.2523L15.6253 4.65552",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43155 16.9915V8.2522",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71622 2.67871L12.1476 6.39439",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.cf1e0d01.svg";
export { ForwardRef as ReactComponent };